import { FC, useMemo } from 'react';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Flex } from 'antd';
import { createColumnHelper } from '@tanstack/react-table';
import translations from './RolePermissionTable.translations.json';
import { PermissionDto, Table } from '@atlas-frontend/sdk';

const { addTranslations, useTranslation } = i18nNsFactory(
  'role-permission-table'
);
addTranslations(translations);

const columnHelper = createColumnHelper<PermissionDto>();

export type RolePermissionTableProps = {
  permissions: PermissionDto[];
};

export const RolePermissionTable: FC<RolePermissionTableProps> = (props) => {
  const { permissions } = props;
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: t('column.name'),
      }),
      columnHelper.accessor('checkScope', {
        header: t('column.checkScope'),
        cell: (props) => t(props.getValue() ? 'yes' : 'no'),
        filterFn: 'includesOption',
        meta: {
          width: '20ch',
          className: 'checkScope',
        },
      }),
    ],
    [t]
  );

  const options = useMemo(
    () => ({
      checkScope: [
        { id: true, name: t('yes') },
        { id: false, name: t('no') },
      ],
    }),
    [t]
  );

  return (
    <Flex align="end" gap="middle" vertical>
      <Table
        name="role-permission-table"
        options={options}
        data={permissions}
        columns={columns}
        sticky
        virtual
        scrollContainerSelector="#detail-layout-main-content"
      />
    </Flex>
  );
};
